export const FLAG_OPTIONS = {
  A: { backgroundColor: "red", borderColor: "red", color: "white" },
  B: { backgroundColor: "yellow", borderColor: "yellow", color: "black" },
  C: { backgroundColor: "green", borderColor: "green", color: "white" },
  D: { backgroundColor: "categorical2", borderColor: "categorical2", color: "white" }, // purple
  E: { backgroundColor: "lightGreen", borderColor: "black", color: "black" },
  F: { backgroundColor: "lightRed", borderColor: "black", color: "black" },
};
export const NO_FLAG = "";
